import React from "react";
import cx from "classnames";
import styles from "./QuoteResultError.module.scss";
import { IResultError } from "../../../interfaces/results/IQuoteResult";
import LModal from "../../../../common/components/Modals/LModal/LModal";
import ModalHeader from "../../../../common/components/Modals/ModalHeader/ModalHeader";
import Button from "../../../../common/components/Forms/Button/Button";

interface IQuoteResultErrorProps {
    isOpen: boolean;
    onClose: () => void;
    //----
    errors: IResultError[];
    className?: string;
}

const QuoteResultError: React.FC<IQuoteResultErrorProps> = (props) => {
    const { errors, className, isOpen, onClose } = props;

    return (
        <LModal
            isOpen={isOpen}
            calcHeightMode="auto"
            width="narrow"
            Header={() => (
                <ModalHeader
                    className={cx(
                        styles["margin-horizontal-ml"],
                        styles["text-section-header"]
                    )}
                    onClose={onClose}
                    title="Insurer not available"
                />
            )}>
            {() => (
                <React.Fragment>
                    {errors.length > 1 ? (
                        errors.map((err, index) => (
                            <ul>
                                <li key={index} className={cx(styles["space-ml"])}>
                                    {err.message}
                                </li>
                            </ul>
                        ))
                    ) : (
                        <span
                            className={cx(
                                styles["space-ml"],
                                "padding-horizontal-xl",
                                "gap-l"
                            )}>
                            {errors[0].message}
                        </span>
                    )}
                    <Button
                        variant="calltoaction"
                        size="s"
                        component="button"
                        width="fill"
                        className={cx(
                            styles["quoteerror-button"],
                            styles["space-pre-l"],
                            styles["padding-horizontal-m"],
                            styles["gap-pre-m"]
                        )}
                        onClick={onClose}>
                        Close
                    </Button>
                </React.Fragment>
            )}
        </LModal>
    );
};

export default QuoteResultError;
